export default {
  statusPublish: 'publish',
  statusDraft: 'draft',
  statusCancelled: 'cancelled',
  statusHidden: 'hidden',
  getStatusLabelWithIcon(status) {
    switch(status) {
      case this.statusPublish:
        return '<i class="fa fa-check"></i> ' + Core.Definition.getDefinition('Publié')
        break
      case this.statusDraft:
        return '<i class="fa fa-edit"></i> ' + Core.Definition.getDefinition('Brouillon')
        break
      case this.statusCancelled:
        return '<i class="fa fa-times"></i> ' + Core.Definition.getDefinition('Annulé')
        break
      case this.statusHidden:
        return '<i class="fa fa-eye-slash"></i> ' + Core.Definition.getDefinition('Caché')
        break
      default:
        return ''
        break
    }
  },
  getStatusLabel(status) {
    switch(status) {
      case this.statusPublish:
        return Core.Definition.getDefinition('Publié');
        break
      case this.statusDraft:
        return Core.Definition.getDefinition('Brouillons');
        break
      case this.statusCancelled:
        return Core.Definition.getDefinition('Annulé');
        break
      case this.statusHidden:
        return Core.Definition.getDefinition('Privé');
        break
      default:
        return ''
        break
    }
  },
  getStatusOptions(keys) {
    if (keys === undefined) {
      keys = [this.statusPublish, this.statusDraft, this.statusPresent, this.statusCancelled, this.statusHidden]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.getStatusLabel(key)
          }
      )
    }
    return options
  }
}
